import { Formik, Form as FormikForm } from 'formik';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import { Check, SlidersHorizontal } from 'lucide-react';
import { ProfileActions } from 'store/actions';
import { CheckboxCard, SectionLegend } from 'components/Profile';
import Header from 'components/Profile/Header';
import { blueCheckboxCardClass, blueCheckboxClass } from 'components/Profile/helper';
import { getInitialValues, validationSchema, timePreferences, reachingMethods } from './helper';

const enhancer = connect(null, { ...ProfileActions });

const Form = ({ preferences, updatePreferences }) => {
  const handleSubmit = async (values) => {
    try {
      await updatePreferences({ patient_setting: values });
      toast.success('Preferences saved successfully');
    } catch (error: any) {
      toast.error(error.errors || 'Failed to save preferences. Please try again later.');
    }
  };

  return (
    <Formik initialValues={getInitialValues(preferences)} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {({ isSubmitting }) => (
        <FormikForm noValidate className="flex min-h-0 flex-1 flex-col">
          <div className="min-h-0 flex-1 overflow-y-auto px-5 pb-7 pt-5 lg:px-6">
            <div className="mb-5 border-b border-gray-100 pb-5">
              <Header
                icon={SlidersHorizontal}
                iconBg="bg-indigo-100"
                iconColor="text-indigo-500"
                title="Preferences"
                description="Appointment & contact preferences"
              />
            </div>

            <SectionLegend optional description="Pick any that work for you, or leave blank if you're flexible.">Best times for appointments</SectionLegend>

            <div className="mb-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {timePreferences.map(({ title, label }) => (
                <CheckboxCard
                  key={`appointment-preference-${title}`}
                  name={`appointment_preferences.${title}`}
                  label={label}
                  className={blueCheckboxCardClass}
                  checkboxClassName={blueCheckboxClass}
                />
              ))}
            </div>

            <SectionLegend optional description="How we send appointment reminders. You'll still see everything here in your portal.">Reminders</SectionLegend>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {reachingMethods.map(({ title, label }) => (
                <CheckboxCard
                  key={`contact-preference-${title}`}
                  name={`contact_preferences.${title}`}
                  label={label}
                  className={blueCheckboxCardClass}
                  checkboxClassName={blueCheckboxClass}
                />
              ))}
            </div>
          </div>

          <div className="flex shrink-0 justify-end border-t border-gray-100 bg-white px-5 py-3 lg:px-6">
            <button type="submit" disabled={isSubmitting} className="btn h-10 min-h-0 gap-2 rounded-xl border-none bg-secondary-900 px-5 font-semibold text-white hover:bg-black">
              {isSubmitting ? <span className="loading loading-spinner loading-sm" /> : <><Check size={15} strokeWidth={2.8} /> Save changes</>}
            </button>
          </div>
        </FormikForm>
      )}
    </Formik>
  );
};

export default enhancer(Form);
